import React from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "semantic-ui-react";
import { withModal, withPopup } from "../hoc";
import { RecordingBulkUpdateForm } from "../forms";

const ButtonWithModalAndPopup = withModal(
  RecordingBulkUpdateForm,
  withPopup(Button)
);

const RecordingBulkUpdateButton = ({ projectId }) => {
  return (
    <ButtonWithModalAndPopup
      projectId={projectId}
      triggerProps={{
        size: "tiny",
        icon: true,
        content: <Icon name="upload" color="blue" />,
        popupProps: { size: "mini", content: "Upload file", inverted: true },
      }}
      modalProps={{ size: "mini" }}
    />
  );
};

RecordingBulkUpdateButton.propTypes = {
  projectId: PropTypes.string.isRequired,
};

export default RecordingBulkUpdateButton;
